/* eslint-disable max-lines */
export const messages = {
    brandName: 'نورونیو',
    date: 'تاریخ',
    creationDate: 'تاریخ ایجاد پرونده',
    week: 'هفته',
    day: 'روز',
    patientList: 'لیست بیماران',
    notExistPatients: 'اطلاعات بیماری تا کنون ثبت نشده است',
    reports: 'گزارش گیری',
    mainSearch: 'نام، نام خانوادگی یا کدملی را جستجو کنید',
    newPatient: 'بیمار جدید',
    appointments: 'نوبت ها',
    waitingRoom: 'در سالن',
    inside: 'در مطب',
    visited: 'ویزیت شده',
    noResult: 'موردی یافت نشد',
    addNewPatient: 'افزودن بیمار جدید',
    logout: 'خروج',
    name: 'نام',
    and: 'و',
    lastname: 'نام خانوادگی',
    deleteAppointment: 'حذف',
    moveAppointmentTo: 'انتقال نویت به',
    movePatientTo: 'انتقال بیمار به لیست',
    NID: 'کد ملی',
    exNID: 'کد اتباع',
    birthDate: 'تاریخ تولد',
    gender: 'جنسیت',
    male: 'مرد',
    female: 'زن',
    nonBinary: 'دیگر',
    single: 'مجرد',
    married: 'متاهل',
    divorced: 'مطلقه',
    widowed: 'فوت همسر',
    maritalStatus: 'وضعیت تاهل',
    firstName: 'نام',
    lastName: 'نام خانوادگی',
    fullName: 'نام و نام خانوادگی',
    search: 'جستجو',
    birthplace: 'محل تولد',
    phoneNo: 'شماره تماس',
    phoneNo2: 'شماره تماس دوم',
    nationality: 'ملیت',
    city: 'شهر',
    address: 'آدرس',
    fatherName: 'نام پدر',
    submitPatient: 'ثبت',
    edit: ' ویرایش',
    cancel: 'لغو',
    optional: 'اختیاری',
    validations: {
        incorrectName: 'نام را صحیح وارد کنید',
        incorrectLastName: 'نام خانوادگی را صحیح وارد کنید',
        exceedMaxLength: 'تعداد کاراکتر بیشتر از حد مجاز است',
        required: 'این فیلد اجباری است',
        incorrectValue: 'فیلد را صحیح وارد کنید',
        emptyPrescription: 'لطفا نسخه را وارد کنید.',
        incompletePrescription: 'لطفا نسخه را کامل وارد کنید.',
        phoneNumber: 'شماره موبایل باید حداقل 11 رقم باشد',
        passwordLength: 'کلمه عبور باید حداقل 8 کاراکتر باشد'
    },
    sidebar: {
        visit: 'ویزیت ',
        laboratory: 'آزمایشگاه',
        newLaboratory: 'آزمایش جدید',
        radiology: 'رادیولوژی',
        medication: 'دارو',
        appointment: 'نوبت دهی',
        patientFile: 'پرونده بیمار',
        forms: 'فرم‌ها',
        newForm: 'فرم جدید',
        form: 'فرم',
        test: 'ازمایش'
    },
    close: 'بستن',
    existFromPatient: 'خروج از پرونده بیمار',
    download: 'دریافت',
    time: 'زمان',
    nationalOrCitizenId: 'کدملی / کد اتباع',
    age: 'سن',
    downloadReports: 'دریافت گزارش',
    downloadReportInPatients: 'دریافت',
    admission: 'پذیرش',
    addNewAppointment: 'نوبت جدید',
    no: 'خیر',
    yes: 'بله',
    hour: 'ساعت',
    reasonOfReferral: 'دلیل مراجعه',
    status: 'وضعیت',
    clinic: 'کلینیک',
    appointment: 'نوبت',
    appointmentStatus: {
        visited: 'ویزیت شده',
        entered: 'وارد کلینیک شده',
        admitted: 'پذیرش شده',
        appointed: 'نوبت داده شده'
    },
    alerts: {
        deleteAppointment: 'آیا از حذف نوبت اطمینان دارید؟',
        askDeleteAppointment: 'آیا از حذف نوبت',
        at: 'در',
        areYouSure: 'اطمینان دارید؟',
        deletePrescription: 'آیا از حذف نسخه دکتر',
        success: 'عملیات با موفقیت انجام شد',
        errorLabImageUpload: 'تعدادی از تصاویر ذخیره نشدند',
        error: 'خطایی رخ داد',
        deleteImageTitle: 'آیا از پاک کردن این عکس مطمئن هستید ؟',
        deleteImageHint: 'عکس پاک شده قابل بازیابی نخواهد بود',
        deleteRadiology: 'آیا از پاک کردن این گزارش مطمئن هستید ؟',
        deleteRadiologyHint: 'گزارش پاک شده قابل بازیابی نخواهد بود',
        deleteFormEntry: 'Are you sure about deleting form of ',
        changeClinic: 'با عوض شدن کلینیک لیست بیمارهای انتخاب شده پاک میشود ایا مطمئن هستید؟',
        deleteFormEntryNew:
            'با حذف این فرم اطلاعات فرم قابل بازیابی نخواهد بود, ایا از حذف فرم اطمینان دارید؟',
        deleteLaboratoryTest:
            'با حذف این آزمایش اطلاعات آزمایش قابل بازیابی نخواهد بود, ایا اطمینان دارید؟',
        unBlockFormRoute:
            'تغییرات ایجاد شده در فرم، در حال حاضر ذخیره نشده است. آیا مایل به بازگشت فرم برای ذخیره هستید؟',
        deletePatient: 'ایا از حذف این بیمار اطمینان دارید؟',
        deleteChanges: 'حذف تغییرات و ادامه',
        returnToForm: 'بازگشت به فرم',
        warningNumberOfPatients:
            'تعداد پرونده های باز بیماران بیشتر از 5 عدد است. برای باز کردن پرونده جدید باید پرونده یک بیمار بسته شود.',
        ok: 'باشه',
        validationPatientForm: ' لطفا فیلد های مورد نظر را با دقت وارد کنید.',
        clinicAccess1: 'کلینیکی با ایدی',
        clinicAccess2: ' در لیست کلینیک های شما وجود ندارد.',
        deleteUser:
            'با حذف کاربر, کاربر از این مجموعه به صورت کامل حذف میشود. آیا از انجام اینکار اطمینان دارید؟',
        deleteExport:
            'با حذف این گزارش اطلاعات گزارش قابل بازیابی نخواهد بود, ایا از حذف این گزارش اطمینان دارید؟'
    },
    synchronousAdmission: 'پذیرش همزمان',
    reserveAppointment: 'رزرو نوبت',
    editAppointment: 'ویرایش نوبت',
    editAppointmentSynchAdmit: 'ویرایش نوبت و پذیرش همزمان',
    submitAppointmentSynchAdmit: 'رزرو نوبت و پذیرش همزمان',
    insurance: 'بیمه',
    insuranceNo: 'شماره بیمه',
    arrivalMode: 'نحوه مراجعه',
    patientCompanionName: 'نام همراه بیمار',
    patientCompanionLastName: 'نام خانوادگی همراه بیمار',
    companionRelationship: 'نسبت همراه بیمار',
    prev: 'مرحله قبل',
    submitAdmission: 'ثبت پذیرش',
    submitAppointmentAndAdmission: 'رزرو نوبت و پذیرش',
    newPrescription: ' نسخه جدید اضافه کنید ',
    // lab
    newLabData: 'آزمایش جدید',
    editLabData: 'ویرایش آزمایش ',
    save: 'ذخیره',
    noLabImageFound: 'تصویر آزمایشی آپلود نشده است',
    noLabDataFound: 'آزمایشی ثبت نشده است',
    addLabImageHint: 'برای ثبت تصویر اینجا کلیک کنید',
    addImage: 'افزودن تصویر',
    saveLab: 'ذخیره آزمایش',
    // radiology
    noReportSelected: 'گزارشی انتخاب نشده است',
    addNewReport: 'گزارش جدید اضافه کنید',
    noReport: 'گزارشی ثبت نشده است',
    newRadiology: 'رادیولوژی جدید',
    editRadiology: 'ویرایش رادیولوژی',
    modality: 'نحوه عکس برداری',
    location: 'لوکیشن',
    requester: 'درخواست کننده',
    hospital: 'بیمارستان',
    submit: 'ثبت',
    saveChanges: 'ذخیره تغییرات',
    delete: 'حذف',
    noLocationFound: 'لوکیشنی وجود ندارد',
    selectFormType: 'انتخاب نوع فرم',
    newForm: 'فرم جدید',
    noFormSubmitted: 'هنوز فرمی ثبت نشده است',
    // forms setting
    formsSetting: 'تنظیمات فرم ها',
    addClinic: 'افزودن کلینیک',
    formName: 'نام فرم',
    clinicsOfForm: 'کلینیک‌ های اختصاص داده شده',
    editForm: 'ویرایش فرم',
    deleteForm: 'حذف فرم',
    formTitle: 'عنوان فرم',
    formDescription: 'توضیحات فرم',
    formUID: 'شناسه فرم',
    complementaryFormInfo: 'اطلاعات تکمیلی',
    formUIDTip: 'اگر Unique Identifier خاصی برای این فرم در نظر دارید',
    selectClinics: 'کلینیک های مورد نظر خود را انتخاب کنید',
    formSubject: 'موضوع فرم',
    sideRightCalenderTooltip: 'نوبت ها',
    changePassword: 'تغییر رمز عبور',
    exist: 'خروج',
    listOfPatients: 'لیست بیماران',
    setting: 'تنظیمات',
    profile: 'پروفایل',
    logOutFromProfile: 'خروج از حساب کاربری',
    dr: 'دکتر',
    forms: 'فرم ها',
    comparison: 'مقایسه',
    back: 'بازگشت',
    selectForm: 'ابتدا فرم خود را انتخاب کنید',
    new: 'جدید',
    registerPrescription: 'ثبت نسخه',
    images: 'تصاویر',
    nextStep: 'مرحله بعد ',
    createReport: 'ایجاد گزارش',
    options: 'گزینه ها',
    deleteFormDialog: {
        text1: 'با انجام این کار, فرم',
        text2: 'شرح حال اولیه بیمار',
        text3: 'و تمام اطلاعات مربوط وابسته به آن',
        text4: 'حذف',
        text5: 'خواهد شد.',
        text6: 'این اطلاعات پس از حذف به هیچ عنوان',
        text7: 'قابل بازیابی نخواهد بود.',
        text8: 'آیا از حذف دائمی این فرم اطمینان دارید؟',
        message: 'در صورت اطمینان، لطفا عبارت زیر را در باکس پایین بنویسید.'
    },
    notExistForm: 'هنوز فرمی برای این بیمار ثبت نشده است!',
    loadingMessage: 'در حال آماده سازی',
    reCreateReport: 'ایجاد مجدد گزارش',
    warningFormReport: 'گزارش های ایجاد شده از فرم ها پس از 7 روز حذف می شوند.',
    createdReportDate: 'زمان ایجاد گزارش',
    editFormStructure: ' ویرایش ساختار فرم',
    editFormTitle: 'ویرایش عنوان فرم',
    editFormInfo: 'ویرایش مشخصات فرم',
    desiredClinic: 'کلینیک های اختصاص داده شده',
    changeClinicMessage: 'با عوض شدن کلینیک ، بیمارهای انتخابی شما بسته میشوند.',
    selectClinicHeader: 'انتخاب کلینیک',
    selectClinicMessage: 'ابتدا از منوی زیر کلینیک مورد نظر خود را انتخاب کنید.',
    login: {
        formHeader: 'ورود به حساب کاربری',
        formMessage: 'شماره تلفن و رمز عبور خود را وارد کنید',
        username: ' شماره تلفن',
        password: 'رمز عبور',
        buttonText: 'ورود',
        usernamePlaceholder: 'نام کاربری را وارد کنید',
        passwordPlaceholder: 'رمز عبور را وارد کنید',
        required: 'این فیلد اجباری است.',
        rememberMe: 'مرا به خاطر بسپار',
        forgetPassword: 'فراموشی رمز عبور؟',
        welcomeMessage: 'به سیناپس خوش آمدید'
    },
    deletePatientFile: 'حذف پرونده بیمار',
    closeMenu: 'جمع شدن منو',
    openMenu: 'باز شدن منو',
    closePatient: 'بستن بیمار',
    newField: 'فیلد جدید',
    fieldName: 'نام فیلد',
    fieldValue: 'مقدار فیلد',
    from: 'از',
    to: 'تا',
    dateOfCreationForm: 'تاریخ ایجاد فرم',
    nameAndLastName: 'نام و نام خانوادگی بیمار',
    validationSearch: {
        maxOfWord: 'حداکثر حروف 30 کاراکتر میباشد.',
        maxOfSelect: 'حداکثر تعداد ایتم ها 10 عدد میباشد.',
        maxAndMinValue: " مقدار فیلد 'از' نمیتواند از مقدار فیلد 'تا' بزرگتر باشد. "
    },
    notAccessClinic: 'شما دسترسی به هیچ کلینیکی ندارید.',
    errorOccurred: 'خطایی رخ داده است',
    editedBy: 'ویرایش شده توسط',
    inDate: 'در تاریخ',
    id: 'ایدی',
    statistics: 'آمار',
    newForms: 'فرم های جدید',
    newPatients: 'بیماران جدید',
    lastWeek: 'هفته گذشته',
    formType: 'نوع فرم',
    total: 'مجموع',
    noResultFound: 'نتیجه ای یافت نشد.',
    formUpdatingDate: 'تاریخ ویرایش فرم',
    permissionsTitle: {
        write_demographic: 'مدیریت پرونده بیمار',
        read_clinical: 'خواندن اطلاعات بالینی',
        write_clinical: 'ورود اطلاعات بالینی',
        aggregate_data: 'گزارش گیری',
        manage_form: 'مدیریت فرم ها',
        manage_user: 'مدیریت  کاربران',
        manage_clinic: 'مدیریت کلینیک ها'
    },
    permissionsDesc: {
        write_demographic: 'کاربر می‌تواند اطلاعات پرونده بیمار و نوبت های او را ویرایش کند.',
        read_clinical:
            'کاربر می‌ تواند اطلاعات بالینی بیمار شامل فرم ها، آزمایشات, دارو و رادیولوژی ها را مشاهده کند.',
        write_clinical:
            'کاربر می تواند اطلاعات بالینی بیمار شامل فرم ها، آزمایشگاه, دارو و رادیولوژی ها را اضافه یا ویرایش کند.',
        aggregate_data:
            'کاربر می تواند از اطلاعات موجود در کلینیک های خود گزارش دریافت کند یا از قسمت جست و جو پیشرفته استفاده کند.',
        manage_form:
            'کاربر می تواند ساختار و عنوان فرم های مربوط به کلینیک خود را ویرایش یا حذف کند.',
        manage_clinic: 'کاربر می تواند کلینیک های‌ موجود را مدیریت یا اضافه کند.',
        manage_user: 'کاربر می‌تواند سایر کاربران را به کلینیک های خود اضافه یا کم کند.'
    },
    user: 'کاربر',
    clinics: 'کلینیک ها',
    polyclinic: 'پلی کلینیک',
    editInfo: 'ویرایش اطلاعات',
    deleteUser: 'حذف کاربر',
    newUser: 'کاربر جدید',
    editUser: 'ویرایش اطلاعات کاربر',
    permission: 'دسترسی ها',
    delegatePerm: 'دسترسی هایی که کاربر می تواند به سایر کاربران اعطا کند',
    addUser: 'افزودن کاربر',
    phoneNumber: 'شماره موبایل',
    userRegistration: 'ثبت کاربر',
    owner: 'مالک',
    you: 'شما',
    relatedClinics: 'کلینیک های مرتبط',
    notFoundUser: 'هیچ کاربری در این کلینیک وجود ندارد',
    noClinicFound: 'کلینیکی وجود ندارد',
    developing: 'در حال توسعه...',
    notFoundListOfForm: 'فرمی ساخته نشده. قبلا از تکمیل یک فرم باید آن را در قسمت تنظیمات بسازید',
    print: 'پرینت',
    medicalCenter: 'مرکز درمانی',
    patientInfo: 'مشخصات بیمار',
    summonPatient: 'پذیرش بیمار در کلینیک',
    summonPatientDesc:
        'بیمار در این کلینیک پذیرش نشده است, میتوانید با کلیک برروی این گزینه بیمار را به کلینیک کنونی اضافه کنید و پرونده بیمار را مشاهده کنید ',
    viewPatientFile: 'مشاهده پرونده بیمار',
    attendingClinics: 'کلینیک های مراجعه کرده',
    attendingClinicsDesc:
        'بیمار در این کلینیک وجود دارد, میتوانید با کلیک برروی این گزینه پرونده بیمار را مشاهده کنید',
    patient: 'بیمار',
    alertMessage: 'این قسمت هنوز در مرحله توسعه ست, ممکن است به درستی عمل نکند.',
    createdBy: 'ایجاد شده توسط',
    title: 'عنوان',
    key: 'کلید(key)',
    viewHeaderWith: 'نمایش سرستون ها با',
    viewMultipleWith: 'نمایش چند گزینه ای ها با',
    identifier: 'شناسه(id)',
    flatSelect: 'choice و others در یک ستون جدا قرار بگیرند',
    clinicName: 'نام کلینیک',
    newClinic: 'کلینیک جدید',
    editClinic: 'ویرایش کلینیک',
    submitClinic: 'ثبت کلینیک',
    listOfReports: 'لیست گزارشات',
    noReportFound: 'گزارشی یافت نشد',
    baseInfo: 'اطلاعات پایه',
    username: 'نام کاربری',
    forgetPassword: 'تغییر کلمه عبور',
    prevPassword: 'کلمه عبور قبلی',
    newPassword: 'کلمه عبور جدید',
    confirmPassword: 'تکرار کلمه عبور جدید',
    notSamePassword: 'کلمه ها ی عبور یکسان نیستند.',
    notFound1: '.شما در حال حاضر به این صفحه دسترسی ندارید',
    notFound2: 'برای ورود به این صفحه دسترسی مربوطه باید توسط ادمین کلینیک به شما داده شود',
    formInfo: 'مشخصات فرم',
    formExportCreatedBy: 'گزارش ایجاد شده توسط',
    allClinics: 'همه کلینیک ها',
    exportFromClinics: 'خروجی از کلینیک:',
    unitNumber: 'شماره پرونده',
    ward: 'بخش',
    room: 'اتاق',
    bed: 'تخت',
    attendingPhysician: 'پزشک معالج',
    admissionDate: 'تاریخ پذیرش',
    occupation: 'شغل',
    dischargDate: 'تاریخ ترخیص'
};
